import { Col, Icon, Row, Typography } from "@visa/vds"
import { AuthContext } from "context/AuthContext"
import React, { useContext, useEffect, useState } from "react"
import { trackPromise } from "react-promise-tracker"
import { ceritificationPackageService } from "services/certification.certificationPackage"
import CertificationPackageDialog from "./CertificationPackageDialog"
import { adminService } from "services/admin.service"
import ContactSection from "pages/UserSettings/CompanyContacts/Components/ContactSection"
import { useForm } from "react-hook-form"
import { GlobalAlertContext } from "context/GlobalAlertContext"

const defaultContact = () => ({
    firstName: "",
    lastName: "",
    businessTitle: "",
    email: "",
    phoneNumber: "",
    countryCode: null,
})

const CertificationPackageCompanyInformation = ({ isEditable, packageBid }) => {
    const userData = useContext(AuthContext);
    const [keyContacts, setKeyContacts] = useState(null)
    const [countries, setCountries] = useState(null)
    const alertContext = useContext(GlobalAlertContext);

    const {
        control,
        handleSubmit,
        getValues,
        register,
        reset,
        formState: { errors },
    } = useForm();

    const loadContacts = async () => {
        trackPromise(
            ceritificationPackageService.GetCertificationPackageKeyContacts(packageBid)
                .then((response) => {
                    if (response.status === 200) {
                        let keyContacts = response.data.result
                        let handledContacts = {
                            certificateTestContactOne: keyContacts.certificateTestContactOne || defaultContact(),
                            certificateTestContactTwo: keyContacts.certificateTestContactTwo || defaultContact()
                        }
                        setKeyContacts(handledContacts)
                        reset(handledContacts)
                    } else {
                        alertContext.setErrorMessage("Error loading contacts")
                    }
                })
                .catch(() => alertContext.setErrorMessage("Error loading contacts"))
        )
    }

    const saveContacts = async () => {
        trackPromise(
            ceritificationPackageService.UpdateCertificationPackageKeyContacts(packageBid, getValues())
                .then((response) => {
                    if (response.status === 200) {
                        let keyContacts = response.data.result
                        let handledContacts = {
                            certificateTestContactOne: keyContacts.certificateTestContactOne || defaultContact(),
                            certificateTestContactTwo: keyContacts.certificateTestContactTwo || defaultContact()
                        }
                        setKeyContacts(handledContacts)
                        alertContext.setSuccessMessage("Successfully saved contacts")
                    } else {
                        alertContext.setErrorMessage("Error saving contacts")
                    }
                })
                .catch(() => alertContext.setErrorMessage("Error saving contacts"))
                .finally()
        )
    }

    const loadCountries = async () => {
        trackPromise(
            adminService.GetAllCountries()
                .then((response) => {
                    setCountries(response.result)
                })
                .catch(() => alertContext.setErrorMessage("Error loading countries list"))
        )
    }

    const openDialog = async () => {
        setEditCompanyContactsDialog(true)
    }


    useEffect(() => {
        if (keyContacts === null) {
            loadContacts()
        }
    }, [keyContacts]);

    let generateField = (label, value) => (
        <Col>
            <Typography className="vss-field-label"><b>{label}</b></Typography>
            <Typography className="vss-field-label">{value || "-"}</Typography>
        </Col>
    )

    let generateKeyContact = (keyContact, idx) => (
        <Col>
            <Row>
                <Typography tag="h4" style={{ marginLeft: "3px" }}>
                    <u>Key Contact {idx}</u>
                </Typography>
            </Row>
            <Row>
                {generateField("First Name", keyContact.firstName)}
                {generateField("Last Name", keyContact.lastName)}
            </Row>
            <Row>
                {generateField("Business Title", keyContact.businessTitle)}
                {generateField("Business Email", keyContact.email)}
            </Row>
            <Row>
                {generateField("Country", countries.find(country => country.id == keyContact.countryCode)?.countryName)}
                {generateField("Business Phone Number", keyContact.phoneNumber)}
            </Row>
        </Col>
    )

    const [editCompanyContactsDialog, setEditCompanyContactsDialog] = useState(false);

    useEffect(() => {
        if (countries === null) loadCountries();
    }, [countries]);
    return (
        <>
            <CertificationPackageDialog open={editCompanyContactsDialog} setOpen={setEditCompanyContactsDialog} title="Company Certification Test Contacts"
                leftButton={{ color: "secondary", text: "Close", handleClick: () => reset(keyContacts) }}
                rightButton={{ color: "primary", text: "Save", handleClick: handleSubmit(saveContacts), remainOpen: true }}
            >
                <Row>
                    <Col>
                        <Row>
                            <Typography tag="h4" style={{ marginTop: "-10px", marginLeft: "3px" }}>
                                <u>Key Contact 1</u>
                            </Typography>
                        </Row>
                        <Row>
                            <ContactSection isReadOnly={false} errors={errors} register={register} control={control} sectionName={"certificateTestContactOne"} updateFormData={() => { }} countries={countries} getValues={getValues} />
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Row>
                            <Typography tag="h4" style={{ marginTop: "-10px", marginLeft: "3px" }}>
                                <u>Key Contact 2</u>
                            </Typography>
                        </Row>
                        <Row>
                            <ContactSection isReadOnly={false} errors={errors} register={register} control={control} sectionName={"certificateTestContactTwo"} updateFormData={() => { }} countries={countries} getValues={getValues} />
                        </Row>
                    </Col>
                </Row>
            </CertificationPackageDialog>

            <Row className="padding-top-0px">
                <Col className="padding-top-0px">
                    <Row>
                        <Typography className="color-visa-blue font-size-14px margin-bottom-0px padding-top-0px" >
                            <b>Company Certification Test Contacts</b>
                            {isEditable && <span className="cursor-pointer" onClick={openDialog}>
                                <span className="certification-package-company-information-update-text cursor-pointer">UPDATE</span>
                                <span className="certification-package-company-information-update-icon"> <Icon name="maximize" resolution="tiny" aria-label="maximize" /></span>
                            </span>
                            }
                        </Typography>
                    </Row>
                    {countries &&
                        <Row className="certification-package-company-information-box padding-top-0px">
                            {keyContacts && generateKeyContact(keyContacts.certificateTestContactOne, 1)}
                            {keyContacts && generateKeyContact(keyContacts.certificateTestContactTwo, 2)}
                        </Row>
                    }
                </Col>
            </Row >
        </>
    )
}

export default CertificationPackageCompanyInformation